const mapboxgl = require("mapbox-gl");
const segmentInsert = require("@mapbox/segmentio-insert");

mapboxgl.accessToken = "pk.eyJ1IjoibGFicy1zYW5kYm94IiwiYSI6ImNqejl3a2o0NDBieWczZXBqNnI4OGxjd24ifQ.PeWoqmCrmHKgMwM6GCAfEg";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", {
  name: "A Story of Boston Coastlines"
});

const colorAccent = "#fff";
let isBlog;
let isMobile;

const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/labs-sandbox/ck22pp23zf0bw1cp7e4van755",
  center: [-71.075, 42.359],
  zoom: 13.1
});

window.innerWidth <= 640 ? isMobile = true : isMobile = false;

// if it's embedded in a blog post
window.location.search.indexOf("embed") !== -1 ? isBlog = true : isBlog = false;

// Disable scroll in posts
isBlog ? map.scrollZoom.disable() : null;

// fly to a different location on load on mobile screen
if (isMobile) {
  map.flyTo({
    center: [-71.061, 42.364],
    zoom: 12.5
  });
}

// Set max bound to the smaller historical map
const SW = [-71.126, 42.312];
const NE = [-70.95, 42.400];
const NE_mobile = [-71.126, 42.405];
map.setMaxBounds([SW, isMobile ? NE_mobile : NE]);
//
const cards = [
  {
    "id": "card-overview",
    "title": "Overview",
    "description": "I used the <a href='https://www.mapbox.com/mapbox-studio/dataset-editor/' target='_blank'>Mapbox Studio dataset editor</a> to trace Boston's coastlines from <a href='http://calvert.hul.harvard.edu:8080/opengeoportal/openGeoPortalHome.jsp?BasicSearchTerm=LayerId:HARVARD.SDE2.MATWN_3764_B6S3_1788_C6' target='_blank'>1788</a> and <a href='http://calvert.hul.harvard.edu:8080/opengeoportal/openGeoPortalHome.jsp?BasicSearchTerm=LayerId:HARVARD.SDE2.MATWN_3764_B6G5_1898_M3' target='_blank'>1898</a>. See how Boston has grown over the centuries!",
    "camera": {
      center: [-71.07572517602875, 42.35955016882079],
      zoom: 13.1
    },
    "cameraBlog": {
      center: [-71.07572517602875, 42.35955016882079],
      zoom: 13.1
    },
    "show1788": true,
    "show1898": true,
    "show2016": true,
    "gotoYear": 9999
  },
  {
    "id": "card-peninsula",
    "title": "The Shawmut Peninsula",
    "description": "Once a small hilly peninsula, little had changed until 1788 since Boston was first built in 1630.",
    "camera": {
      center: [-71.07176780684654, 42.35586158920927],
      zoom: 13.55
    },
    "cameraBlog": {
      center: [-71.0744, 42.3554],
      zoom: 12.9
    },
    "show1788": true,
    "show1898": false,
    "show2016": false,
    "showYear": 1788
  },
  {
    "id": "card-grid",
    "title": "A Legacy in Streets",
    "description": "In Cambridge today, the triangle space between Main Street and Mass Ave are still reminiscent of the historical shorelines.",
    "camera": {
      center: [-71.0934895258428, 42.35682240092123],
      zoom: 14.2
    },
    "cameraBlog": {
      center: [-71.09216088392276, 42.360910001881734],
      zoom: 13.567
    },
    "show1788": true,
    "show1898": false,
    "show2016": false,
    "gotoYear": 1788
  },
  {
    "id": "card-backbay",
    "title": "The Back Bay",
    "description": "By 1820 landfill projects had begun, including the filling of <a href='https://en.wikipedia.org/wiki/Back_Bay,_Boston' target='_blank'>the Back Bay</a>, which nearly doubled the size of Boston peninsula.",
    "camera": {
      center: [-71.08635875418763, 42.35457447576792],
      zoom: 13.55
    },
    "cameraBlog": {
      center: [-71.08386, 42.3524],
      zoom: 13.17
    },
    "show1788": true,
    "show1898": true,
    "show2016": false,
    "gotoYear": 1898
  },
  {
    "id": "card-airport",
    "title": "Logan Airport (BOS)",
    "description": "The area which became Logan airport today began to be filled as late as in 1922.",
    "camera": {
      center: [-71.01973397995576, 42.36449170568267],
      zoom: 13
    },
    "cameraBlog": {
      center: [-71.0239, 42.3638],
      zoom: 12.7
    },
    "show1788": false,
    "show1898": true,
    "show2016": true,
    "gotoYear": 2016
  }
];

const markup_grid = {
  "type": "FeatureCollection",
  "features": [{
    "geometry": {
      "coordinates": [
        [
          -71.07163789207728,
          42.361276180837336
        ],
        [
          -71.10044056883004,
          42.36349888912406
        ]
      ],
      "type": "LineString"
    },
    "type": "Feature",
    "properties": {
      "name": "Main St",
      "card": "card-grid",
      "paint": {
        "line-width": 3,
        "line-color": colorAccent
      },
      "order": "road-rail"
    }
  }, {
    "geometry": {
      "coordinates": [
        [
          -71.06148405916029,
          42.32045556502095
        ],
        [
          -71.07164328986534,
          42.33218810792718
        ],
        [
          -71.08041859253582,
          42.339296044656635
        ],
        [
          -71.0817002770592,
          42.34057435631095
        ],
        [
          -71.085934863903,
          42.34342691409441
        ],
        [
          -71.09312172439807,
          42.35832040082249
        ],
        [
          -71.09369308991785,
          42.3592154755633
        ],
        [
          -71.09456156550804,
          42.35997543467488
        ],
        [
          -71.09604711585968,
          42.36088737347612
        ],
        [
          -71.10703671991827,
          42.367418532119075
        ],
        [
          -71.10772581096826,
          42.36786238495631
        ],
        [
          -71.10887429605151,
          42.368449832418776
        ],
        [
          -71.1126908003281,
          42.36982052180045
        ],
        [
          -71.1160302415702,
          42.37257486430394
        ],
        [
          -71.11854326991411,
          42.37332068126378
        ],
        [
          -71.11881268474829,
          42.37375907528528
        ],
        [
          -71.1187962771347,
          42.37430610196145
        ],
        [
          -71.12013022046887,
          42.3777353500476
        ],
        [
          -71.1191456799959,
          42.3872019202995
        ],
        [
          -71.11972533969093,
          42.38917371883946
        ],
        [
          -71.12101488165605,
          42.39032900776468
        ],
        [
          -71.12387127867582,
          42.391739144588286
        ],
        [
          -71.1286915135343,
          42.39596936436766
        ]
      ],
      "type": "LineString"
    },
    "type": "Feature",
    "properties": {
      "name": "MassAve",
      "card": "card-grid",
      "paint": {
        "line-width": 3,
        "line-color": colorAccent
      },
      "order": "road-rail"
    }
  }]
};

const markup_empty = {
  "type": "FeatureCollection",
  "features": []
};

let activeCard = 0;

const yearClick = function () {
  // Get current year
  const year_active = this.id.substring(1);
  showYear(year_active, this.classList.contains("stroke"));
};
document.getElementById("card").getElementsByTagName("h2")[0].innerHTML = `${cards[activeCard].title}`;
document.getElementById("card").getElementsByTagName("p")[0].innerHTML = `${cards[activeCard].description}`;

map.on("load", () => {
  // Move navigations to bottom-left on mobile screens
  map.addControl(new mapboxgl.NavigationControl(isMobile ? {
    position: "bottom-left"
  } : {
    position: "top-right"
  }));

  // Add highlight layer for the slideshow;
  addLayers();


  // Add interactions to control buttons
  Array.from(document.getElementsByClassName("year")).forEach(element => {
    element.addEventListener("click", yearClick);
  });

  // Slideshow
  document.getElementById("next").onclick = () => {
    // Go to next cardID
    if (activeCard === (cards.length - 1)) {
      activeCard = 0;
    } else {
      activeCard++;
    }
    updateCard(activeCard);
  };

  document.getElementById("prev").onclick = () => {
    // Go to next cardID
    if (activeCard === 0) {
      activeCard = cards.length - 1;
    } else {
      activeCard--;
    }
    updateCard(activeCard);
  };

  map.on("dragend", () => {
    const center = map.getCenter();
    document.getElementById("center").innerHTML = `${center.lng}, ${center.lat}`;
  });

  map.on("zoomend", () => {
    document.getElementById("zoom").innerHTML = `${map.getZoom()}`;
  });
});


// Update map/text to the given cardID
function updateCard(i) {
  // Update slideshow content
  document.getElementById("card").getElementsByTagName("h2")[0].innerHTML = `${cards[activeCard].title}`;
  document.getElementById("card").getElementsByTagName("p")[0].innerHTML = `${cards[i].description}`;

  // Update map
  map.easeTo(isBlog ? cards[i].cameraBlog : cards[i].camera);

  showYear(1898, cards[i].show1898);
  showYear(1788, cards[i].show1788);
  showYear(2016, cards[i].show2016);

  // Update markup layer
  if (cards[i].id === "card-grid") {
    map.getSource("markup").setData(markup_grid);
  } else {
    map.getSource("markup").setData(markup_empty);
  }
}

function addLayers() {
  // Add empty geojson source for markup layer by default
  map.addSource("markup", {
    type: "geojson",
    data: markup_empty
  });

  // Add the markup layer right above the coastline layers
  map.addLayer({
    "id": "markup",
    "type": "line",
    "source": "markup",
    "paint": {
      "line-color": colorAccent,
      "line-width": 1,
      "line-dasharray": [4, 2]
    }
  }, "wave1788");
}

// Show year with checkbox buttons
function showYear(year, visible) {
  if (visible) {
    map.setLayoutProperty(`water${year}`, "visibility", "visible");
    map.setLayoutProperty(`wave${year}`, "visibility", "visible");
    document.getElementById(`y${year}`).classList.remove("stroke");
  } else {
    map.setLayoutProperty(`water${year}`, "visibility", "none");
    map.setLayoutProperty(`wave${year}`, "visibility", "none");
    document.getElementById(`y${year}`).classList.add("stroke");
  }
}
